








import { defineComponent } from '@nuxtjs/composition-api';
import { BaseImage } from '@shared/ui';
import { getStoryblokImageURL } from '@unified-commerce/gpc-vue-storefront-storyblok';

export default defineComponent({
  name: 'SbImage',
  components: { BaseImage },
  props: {
    attrs: {
      type: Object,
      required: true,
    },
  },
  computed: {
    desktopSrc(): string {
      return getStoryblokImageURL(this.attrs?.src);
    },
    tabletSrc(): string {
      return getStoryblokImageURL(this.attrs?.src, {
        width: 1024,
      });
    },
    mobileSrc(): string {
      return getStoryblokImageURL(this.attrs?.src, {
        width: 768,
      });
    },
    alt(): string {
      return this.attrs?.alt || '';
    },
  },
});
